export type ProgressBarProps = { progress: number };

const ProgressBar = ({ progress }: ProgressBarProps) => {
  return (
      <div className="cq-w-full cq-bg-white cq-h-[3px] cq-rounded-[50px] cq-flex-shrink-0">
      <div
        className="cq-bg-[#336AFF] cq-h-full cq-rounded-full cq-transition-all cq-duration-300 cq-ease-in-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default ProgressBar;
